import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES, CONTACT_EMAIL } from "../data/site";

export const Footer = () => {
  const { t } = useLanguage();

  const nav = [
    { label: t.nav.home, p: "/" },
    { label: t.nav.terminal, p: "/terminal" },
    { label: t.nav.operations, p: "/operacoes" },
    { label: t.nav.infrastructure, p: "/infraestrutura" },
    { label: t.nav.cabotage, p: "/cabotagem" },
    { label: t.nav.group, p: "/grupo" },
    { label: t.nav.contact, p: "/contato" },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-ops bg-[#050b12]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-5">
          <span className="bg-white rounded-lg px-3 py-2 inline-flex items-center">
            <img src={IMAGES.opsLogo} alt="Open Port Services" className="h-10 w-auto" />
          </span>
          <p className="text-sm text-ops-muted max-w-sm">{t.footer.tagline}</p>
          <p className="text-xs text-ops-muted mono-tag uppercase tracking-widest">{t.footer.location}</p>
        </div>

        <div className="md:col-span-3">
          <span className="mono-tag text-[10px] text-ops-light uppercase tracking-widest block mb-4">
            {t.footer.navTag}
          </span>
          <ul className="space-y-2.5 text-sm text-ops-muted">
            {nav.map((n) => (
              <li key={n.p}>
                <Link to={n.p} data-testid={`footer-nav-${n.p.replace("/", "") || "home"}`} className="hover:text-white transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4 space-y-4">
          <span className="mono-tag text-[10px] text-ops-light uppercase tracking-widest block">
            {t.footer.contactTag}
          </span>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email"
            className="flex items-start gap-2.5 text-sm text-ops-muted hover:text-white transition-colors"
          >
            <Mail size={15} className="mt-0.5 shrink-0 text-ops-light" />
            {CONTACT_EMAIL}
          </a>
          <div className="flex items-start gap-2.5 text-sm text-ops-muted">
            <MapPin size={15} className="mt-0.5 shrink-0 text-ops-light" />
            <span>{t.contact.infoAddr1}</span>
          </div>
          <div className="flex items-start gap-2.5 text-sm text-ops-muted">
            <MapPin size={15} className="mt-0.5 shrink-0 text-ops-light" />
            <span>{t.contact.infoAddr2}</span>
          </div>

          <div className="pt-4 border-t border-ops">
            <span className="mono-tag text-[10px] text-ops-light uppercase tracking-widest block mb-3">
              {t.footer.groupTag}
            </span>
            <div className="flex items-center gap-3 opacity-70">
              <span className="bg-white/90 rounded px-2 py-1 inline-flex items-center">
                <img src={IMAGES.evkLogo} alt="EVK Agency" className="h-6 w-auto" />
              </span>
              <span className="text-xs text-ops-muted">{t.footer.evk}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-ops">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] text-ops-muted mono-tag uppercase tracking-widest">
          <span data-testid="footer-rights">{t.footer.rights}</span>
          <span>TUP OPEN PORT • TUP — TERMINAL DE USO PRIVADO</span>
        </div>
      </div>
    </footer>
  );
};
